import api from 'api'
import { Company } from 'api/typings'

type GetCompaniesForFiltersRequest = {
  grouping?: 'upcoming' | 'past' | 'ongoing'
}

type GetCompaniesForFiltersResponse = {
  data: { admin: { companiesForFilters: Company[] } }
}

export const getCompaniesForFilters = async (
  request: GetCompaniesForFiltersRequest
) => {
  const response = await api.post<GetCompaniesForFiltersResponse>(
    '/admin/graphql_dispatch/companies_for_filters_b8c9d2e1',
    {
      grouping: request.grouping,
    }
  )

  return response.data.data.admin.companiesForFilters
}
